import LoaderWithBackdrop from "@/components/custom/LoaderWithBackdrop";
import { crmRegistry } from "@/features/crm_system/lib/_core/crmRegistry";
import { AllCrmsFieldsTypes } from "@/features/crm_system/lib/_core/crmSystem";
import React, { Suspense } from "react";
import { FieldContextProps, FieldRendererProvider } from ".";



export const FieldRenderer = React.memo(function (props: FieldContextProps) {
    const Field = crmRegistry.getFieldRendererField(props.crmSystem, props.question.field_type as AllCrmsFieldsTypes);
    return (
        // TODO: Add different loader here
        <Suspense fallback={<LoaderWithBackdrop />}>
            <FieldRendererProvider {...props}>
                <Field />
            </FieldRendererProvider>
        </Suspense>
    )
}, (prevProps, nextProps) => {
    return prevProps.question === nextProps.question;
});



